<template>
  <main class="all-models">
    <div class="all-models__container">
      <model-card
        v-for="model in models"
        :key="model.id"
        :name="model.name"
        :id="model.id"
        :image="model.preview.url"
      ></model-card>
      <div ref="observable"></div>
    </div>
  </main>
</template>

<script>
import ModelCard from '../components/ModelCard'
import { apiGetModels } from '../utils/api'
import {
  SET_CLIENT_MALEMODELS,
  SET_CLIENT_FEMALEMODELS,
} from '../store/mutations-names'

export default {
  name: 'AllModels',
  components: {
    ModelCard
  },
  data() {
    return {
      models: [],
      intersectionObserver: null,
      isLoading: false,
      nextPage: 1,
      gender: ''
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.gender = to.params.gender == 'men' ? 'male' : 'female'
    this.loadInitialData()
    next()
  },
  mounted() {
    this.gender = this.$route.params.gender == 'men' ? 'male' : 'female'
    // setup intersectionObserver
    this.intersectionObserver = new IntersectionObserver(this.loadMoreData, {
      root: null,
      threshold: 0
    })
    this.intersectionObserver.observe(this.$refs.observable)
    // loadInitialData
    this.loadInitialData()
  },
  methods: {
    async loadInitialData() {
      this.isLoading = true
      // check male models store
      if (this.gender == 'male' && this.$store.state.clientMaleModels.length) {
        this.models = this.$store.state.clientMaleModels
        this.nextPage = this.$store.state.clientLastMaleDoc
      // check female models store
      } else if (this.gender == 'female' && this.$store.state.clientFemaleModels.length) {
        this.models = this.$store.state.clientFemaleModels
        this.nextPage = this.$store.state.clientLastFemaleDoc
      // if store is empty load models from firestore
      } else {
        this.models = []
        try {
          let result = await apiGetModels(this.nextPage, this.gender)
          this.models = result.docs
          if (result.hasNextPage) {
            this.nextPage++
          } else {
            this.nextPage = null
          }
          // store fetched models in Vuex
          if (this.gender == 'male') {
            this.$store.commit(SET_CLIENT_MALEMODELS, { models: this.models, lastDoc: this.nextPage})
          } else {
            this.$store.commit(SET_CLIENT_FEMALEMODELS, { models: this.models, lastDoc: this.nextPage})
          }
        } catch(e) {
          console.error(e.message)
          this.isLoading = false
        }
        this.isLoading = false
      }
      this.isLoading = false
    },
    async loadMoreData(entries) {
      if (this.isLoading || !this.nextPage) {
        return
      }
      this.isLoading = true
      entries.forEach(async (entry) => {
        if (entry.isIntersecting) {
          try {
            let result = await apiGetModels(this.nextPage, this.gender)
            this.models.push(...result.docs)
            if (result.hasNextPage) {
              this.nextPage++
            } else {
              this.nextPage = null
            }
            // store fetched models in Vuex
            if (this.gender == 'male') {
              this.$store.commit(SET_CLIENT_MALEMODELS, { models: this.models, lastDoc: this.nextPage})
            } else {
              this.$store.commit(SET_CLIENT_FEMALEMODELS, { models: this.models, lastDoc: this.nextPage})
            }
          } catch(e) {
            console.error(e.message)
            this.isLoading = false
          }
          this.isLoading = false
        }
      })
      this.isLoading = false
    }
  }

}
</script>

<style lang="scss" scoped>
.all-models {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 45px 45px 85px;

  &__container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
    row-gap: 10px;
    column-gap: 10px;
    flex-grow: 0;
    width: 100%;
    max-width: 1064px;
  }
}

@media screen and (max-width: 767px) {
  .all-models {
    padding: 12px 12px 55px;
    &__container {
      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
      row-gap: 12px;
      column-gap: 12px;
    }
  }
}
</style>